import axiosNewApi from "config/axiosNewApi"
import Cookies from "js-cookie";

export const userApi = {
    get: async () => {
        return await axiosNewApi.get("mobile/users/profile" , {
            withCredentials: true
        })
    },
    updatePassword: async (values) => {
        const response = await axiosNewApi.post('mobile/users/change-password' , values , {
            withCredentials: true
        })
        return response;

    }
    ,
    logout: async () => {
        const response = await axiosNewApi.post('auth/logout', {}, {
            withCredentials: true
        });
        return response;
    }
    ,
    resetRequest: async (values) => {
        const response = await axiosNewApi.post('auth/request-reset-password' , values , {
            withCredentials: true
        })
        return response;
    }
    ,
    validateResetToken : async (token , email) => {
        const response = await axiosNewApi.get(`auth/check-reset-token?token=${token}&email=${email}` , {
            withCredentials: true
        });
        return response;
    },
    resetPassword: async (values) => {
        const response = await axiosNewApi.post('auth/reset-password' , values , {
            withCredentials: true
        })
        return response;

    }
}